
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/[slug]",
      function () {
        return require("private-next-pages/section/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/[slug]"])
      });
    }
  